import type { LucideIcon } from "lucide-react";
import type { ComponentProps, ReactNode } from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/v2/alert";
import { Button } from "@/components/ui/v2/button";

type FixAlertProps = Pick<ComponentProps<typeof Alert>, "variant" | "role"> & {
  icon: LucideIcon;
  fixIcon: LucideIcon;
  title: ReactNode;
  description: ReactNode;
  fixLabel: ReactNode;
  actions?: ReactNode;
  testId?: string;
  fixTestId?: string;
  onFix: () => void;
};

export function FixAlert({
  variant,
  role = "alert",
  icon: Icon,
  fixIcon: FixIcon,
  title,
  description,
  fixLabel,
  actions,
  testId,
  fixTestId,
  onFix,
}: FixAlertProps) {
  return (
    <Alert
      variant={variant}
      role={role}
      data-testid={testId}
      className="items-center has-[>svg]:grid-cols-[auto_1fr_auto]"
    >
      <Icon aria-hidden />
      <div>
        <AlertTitle className="line-clamp-none">{title}</AlertTitle>
        <AlertDescription>{description}</AlertDescription>
      </div>
      <div className="flex items-center gap-2">
        {actions}
        <Button type="button" onClick={onFix} data-testid={fixTestId}>
          <FixIcon />
          {fixLabel}
        </Button>
      </div>
    </Alert>
  );
}
